import { useEffect, useState } from 'react';
import { getTripTimeline, type TripTimeline } from '../trip-timeline.api';

export type TripTimelineState = { status: 'loading' } | { status: 'loaded'; timeline: TripTimeline } | { status: 'error' };

/** The trip's timeline, read afresh each time the tab opens: it is derived from the log on the server, never kept. */
export function useTripTimeline(tripId: string): TripTimelineState {
  const [state, setState] = useState<TripTimelineState>({ status: 'loading' });

  useEffect(() => {
    let cancelled = false;
    getTripTimeline(tripId)
      .then((timeline) => !cancelled && setState({ status: 'loaded', timeline }))
      .catch(() => !cancelled && setState({ status: 'error' }));
    return () => {
      cancelled = true;
    };
  }, [tripId]);

  return state;
}
